export const EnrollmentDTO = {
    list: (raw) => {
        const date =
            raw.enrolledAt || raw.timestamps?.createdAt;

        const trDate = date
            ? new Date(date).toLocaleDateString("tr-TR", {
                day: "2-digit",
                month: "long",
                year: "numeric"
            })
            : "-";

        return {
            publicId: raw.publicId,
            fullName: `${raw.firstName} ${raw.lastName}`,

            phone: raw
                ? `${raw.countryCode} ${raw.phoneNumber}`
                : raw.phone,

            status: raw.status,
            termName: raw.termName,
            interestArea: raw.interestArea,
            source: raw.source,
            enrolledAt: trDate
        };
    },

    detail: (raw) => ({
        publicId: raw.publicId,

        personal: {
            fullName: `${raw.firstName} ${raw.lastName}`,
            identityDocumentType: raw.identityDocumentType,
            tckn: raw.tckn,
            passportNumber: raw.passportNumber,
            gender: raw.gender,
            birthDate: raw.birthDate,
            nationality: raw.nationality,
        },

        contact: {
            email: raw.email,
            phone: raw.countryCode && raw.phoneNumber
                ? `${raw.countryCode} ${raw.phoneNumber}`
                : null,
            city: raw.city,
            address: raw.address,
        },

        education: {
            profession: raw.profession,
            interestArea: raw.interestArea,
        },

        enrollment: {
            status: raw.status,
            source: raw.source,
            termId: raw.termId,
            termName: raw.termName,
            enrolledAt: raw.enrolledAt,
            completedAt: raw.completedAt,
            droppedAt: raw.droppedAt,
        },

        adminNote: raw.adminNote,
    }),
};
